<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import { mapMutations, mapActions } from 'vuex';
import { Howler } from 'howler';
import registerServiceWorkers from '@/common/serviceWorkers';

export default {
  name: 'app',
  created() {
    this.getVersionInfo();
    this.enableGTM();
    this.addExternalSEOScript();
    this.updateSoundsStatusFromLocaleStorage();
    this.loadFireBaseScript();
    // Setting global audio volume.
    Howler.volume(0.8);
    registerServiceWorkers();
  },
  methods: {
    ...mapActions('common', [
      'storeVersionInfo',
    ]),
    ...mapMutations('common', [
      'updateSoundsStatusFromLocaleStorage',
    ]),
    initFireBase(config) {
      /* eslint-disable */
      if (!firebase.apps.length) {
        console.log('About to initialize FireBase...');
        firebase.initializeApp(JSON.parse(config));
      } else {
        console.log('FireBase is already initialized!');
      }
      /* eslint-enable */
    },
    loadFireBaseScript() {
      this.$axios.get('api/getFireBaseConfigProperties').then((response) => {
        const config = response.data.data;
        if (config) {
          const oldNoScript = document.querySelector('#fireBaseScript');
          if (!oldNoScript) {
            const firebaseScript = document.createElement('script');
            if (firebaseScript.readyState) {
              firebaseScript.onreadystatechange = () => {
                if (firebaseScript.readyState === 'loaded' || firebaseScript.readyState === 'complete') {
                  firebaseScript.onreadystatechange = null;
                  this.initFireBase(config);
                }
              };
            } else firebaseScript.onload = () => this.initFireBase(config);
            firebaseScript.setAttribute('id', 'fireBaseScript');
            firebaseScript.setAttribute('src', 'https://www.gstatic.com/firebasejs/6.2.4/firebase-app.js');
            document.head.insertBefore(firebaseScript, document.head.childNodes[0]);
          }
        }
      });
    },
    getVersionInfo() {
      this.storeVersionInfo();
    },
    enableGTM() {
      this.$axios('publicapi/getGTMInfo').then((response) => {
        const key = response.data.data;
        if (key) {
          /* eslint-disable */
          // add GMT noscript (no js support case) to body
          const oldNoScript = document.querySelector('#gtmNoScript');
          if (!oldNoScript) {
            const noscript = document.createElement('noscript');
            noscript.setAttribute('id', 'gtmNoScript');
            noscript.innerHTML = `<iframe height="0" width="0" style="display:none;visibility:hidden" src="https://www.googletagmanager.com/ns.html?id=${key}"></iframe>`;
            document.body.insertBefore(noscript, document.body.childNodes[0]);
          }
          // add GMT script to head
          const oldScript = document.querySelector('#gtmScript');
          if (!oldScript) {
            const script = document.createElement('script');
            script.setAttribute('id', 'gtmScript');
            script.innerHTML = "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','" + key + "')";
            document.head.appendChild(script);
          }
          /* eslint-enable */
        }
      });
    },
    addExternalSEOScript() {
      const script = document.createElement('script');
      script.setAttribute('type', 'application/ld+json');
      script.innerHTML = '{ "@context" : "http://schema.org", "@type" : "SoftwareApplication", "name" : "Duel Multiplayer Trivia Game", "image" : "https://www.duel.ae/static/images/get_started.png", "url" : "https://www.duel.ae/#/login", "aggregateRating" : { "@type" : "AggregateRating", "ratingValue" : "5" } }';
      document.body.appendChild(script);
    },
  },
};
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>



// WEBPACK FOOTER //
// src/App.vue